import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

// Shown in place of any member-only page for free or lapsed accounts; saved data is kept for renewal.
export function MembersOnly({ feature = "This feature" }) {
  return (
    <section className="px-6 lg:px-16 pt-32 lg:pt-40 pb-24" data-testid="members-only-panel">
      <div className="max-w-xl mx-auto fs-card p-10 text-center">
        <Lock className="w-5 h-5 mx-auto mb-4 fs-accent" strokeWidth={1.4} aria-hidden="true" />
        <div className="text-xs tracking-widest uppercase mb-3 fs-accent">Members</div>
        <h1 className="fs-serif text-2xl lg:text-3xl mb-4">{feature} is part of membership</h1>
        <p className="text-sm leading-relaxed fs-text-2 mb-8">
          Your Orders, saved farms and free features stay right where they are. If you were a member before,
          everything you saved is kept and returns as soon as your membership is active again.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/subscribe" className="fs-btn" data-testid="members-only-upgrade">Check your ZIP &amp; join</Link>
          <Link to="/explore" className="fs-btn-2" data-testid="members-only-back">Back to Your Farmstand</Link>
        </div>
      </div>
    </section>
  );
}
